<template>
    <button class="hamburger hamburger--slider flex items-center"  type="button">
        <span class="hamburger-box">
           <span :style="`--variant: ${color};`" class="hamburger-inner"></span>
        </span>
    </button>
</template>

<script>
export default {
    name: "AtomIcMenu",
    props: {
        width: {
            type: Number,
            default: 30
        },
        height: {
            type: Number,
            default: 30
        },
        color: {
            type: String,
            default: 'black'
        },
    }
}
</script>

<style scoped>
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    background-color: var(--variant);
}
</style>
